export default "__VITE_ASSET__vxB2aSqR__"